// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heading-image-section[data-v-e9f4c96a]{padding:25px 0}.title[data-v-e9f4c96a]{font-weight:700;text-align:center}.lazy-image[data-v-e9f4c96a]{max-width:100%;margin:0 auto;height:auto}.mobile-image[data-v-e9f4c96a]{display:block}@media(min-width:768px){.mobile-image[data-v-e9f4c96a]{display:none}}.desktop-image[data-v-e9f4c96a]{display:none}@media(min-width:768px){.desktop-image[data-v-e9f4c96a]{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
